var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{ref:"bar",staticStyle:{"width":"100%","height":"80vh"},attrs:{"option":_vm.bar,"init-option":_vm.initOptions,"theme":"ovilia-green","auto-resize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }